namespace Matrix.Rebalancer {
    export interface SummaryViewAccountForm {
        InstanceCode: Serenity.StringEditor;
        AccountCode: FormatServiceLookupEditor;
        SortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SummaryViewAccountForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SummaryViewAccount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SummaryViewAccountForm.init)  {
                SummaryViewAccountForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatServiceLookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(SummaryViewAccountForm, [
                    'InstanceCode', w0,
                    'AccountCode', w1,
                    'SortOrder', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
